export function setCookie(name: string, value: string, cookieDuration: number | null) {
  let expires = '';
  if (cookieDuration) {
    const cookieExpireDate = new Date(Date.now() + cookieDuration * 1000);
    expires = `;expires=${cookieExpireDate.toUTCString()}`;
  }
  document.cookie = `${name}=${value};path=/;secure${expires}`;
}

export function getCookie(name: string) {
  const namePrefix = name + "=";
  const value = document.cookie
    .split(';')
    .map(c => c.trim())
    .find(c => c.startsWith(namePrefix))
    ?.substring(namePrefix.length) || '';
  return value ? decodeURIComponent(value) : null;
}

export interface UrlUtmData {
  page_url: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

export function captureUrlAndUtmData(): UrlUtmData {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  const data: UrlUtmData = {
    page_url: url.href,
  };

  // Capture UTM parameters if they exist
  const utmSource = searchParams.get("utm_source");
  if (utmSource) data.utm_source = utmSource;

  const utmMedium = searchParams.get("utm_medium");
  if (utmMedium) data.utm_medium = utmMedium;

  const utmCampaign = searchParams.get("utm_campaign");
  if (utmCampaign) data.utm_campaign = utmCampaign;

  const utmTerm = searchParams.get("utm_term");
  if (utmTerm) data.utm_term = utmTerm;

  const utmContent = searchParams.get("utm_content");
  if (utmContent) data.utm_content = utmContent;

  return data;
}


export function playNotificationSound() {
  try {
    const context = new AudioContext();
    const start = context.currentTime;
    [880, 1318.5].forEach((frequency, index) => {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      const noteStart = start + index * 0.12;
      oscillator.type = 'sine';
      oscillator.frequency.value = frequency;
      gain.gain.setValueAtTime(0, noteStart);
      gain.gain.linearRampToValueAtTime(0.15, noteStart + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.001, noteStart + 0.4);
      oscillator.connect(gain).connect(context.destination);
      oscillator.start(noteStart);
      oscillator.stop(noteStart + 0.4);
    });
    setTimeout(() => context.close(), 1000);
  } catch {}
}
